// extracted by mini-css-extract-plugin
module.exports = {"logo":"src-components-CompanyDetails-CardDetailsForm-CardDetailsForm-module__logo--U-ffX"};